import { render, staticRenderFns } from "./MyCourse.vue?vue&type=template&id=f5aa218e&scoped=true"
import script from "./MyCourse.vue?vue&type=script&lang=js"
export * from "./MyCourse.vue?vue&type=script&lang=js"
import style0 from "./MyCourse.vue?vue&type=style&index=0&id=f5aa218e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5aa218e",
  null
  
)

export default component.exports